import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function PaginationBar({attendancePage, totalAttendancePage, setAttendancePage }) {
  return (
    <div className="w-full flex justify-end p-3">
      <section className="flex items-center justify-center gap-3">
        <p className="text-[15px]">
          {attendancePage} of {totalAttendancePage} Pages
        </p>
        <div className="flex items-center justify-center">
          <button
            disabled={attendancePage === 1 ? true : false}
            className="px-2"
            onClick={() => setAttendancePage((prev) => prev - 1)}
          >
            <IoIosArrowBack
              className={`${
                attendancePage === 1 ? "text-slate-300" : "text-slate-500"
              } text-[20px]`}
            />
          </button>
          <button
            disabled={attendancePage === totalAttendancePage ? true : false}
            className="px-2"
            onClick={() => setAttendancePage((prev) => prev + 1)}
          >
            <IoIosArrowForward
              className={`${
                attendancePage === totalAttendancePage
                  ? "text-slate-300"
                  : "text-slate-500"
              } text-[20px]`}
            />
          </button>
        </div>
      </section>
    </div>
  );
}

export default PaginationBar;
